<div class="p-4">
  <div class="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 mb-4 flex items-start gap-3">
    <i class="bi bi-info-circle-fill text-blue-500 text-lg mt-0.5"></i>
    <div>
      <p class="text-sm font-semibold text-blue-800">Módulo de Facturación Electrónica</p>
      <p class="text-xs text-blue-600 mt-0.5">
        Emite facturas, boletas y guías de remisión electrónicas a SUNAT. Este módulo
        <strong>no afecta</strong> ventas, caja ni inventario (salvo que actives "Descontar
        inventario").
      </p>
    </div>
  </div>

  <div class="flex gap-2 mb-4 flex-wrap">
    <button
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      [class.bg-blue-600]="vista() === 'emitir'"
      [class.text-white]="vista() === 'emitir'"
      [class.bg-gray-200]="vista() !== 'emitir'"
      [class.text-gray-700]="vista() !== 'emitir'"
      (click)="vista.set('emitir')"
    >
      📄 Comprobantes
    </button>
    <button
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      [class.bg-blue-600]="vista() === 'guias'"
      [class.text-white]="vista() === 'guias'"
      [class.bg-gray-200]="vista() !== 'guias'"
      [class.text-gray-700]="vista() !== 'guias'"
      (click)="vista.set('guias')"
    >
      🚚 Guías de Remisión
    </button>
    <button
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      [class.bg-blue-600]="vista() === 'historial'"
      [class.text-white]="vista() === 'historial'"
      [class.bg-gray-200]="vista() !== 'historial'"
      [class.text-gray-700]="vista() !== 'historial'"
      (click)="vista.set('historial'); cargarHistorial()"
    >
      📋 Historial
    </button>
  </div>

  <!-- ═══════════ VISTA COMPROBANTES ═══════════ -->
  @if (vista() === 'emitir') {
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div class="lg:col-span-2 space-y-4">
        <div class="bg-white rounded-lg shadow p-4">
          <h3 class="font-semibold text-slate-800 mb-3">1. Cliente</h3>
          <app-buscador-cliente [(cliente)]="formFacturacion().controlValue().cliente" />
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <h3 class="font-semibold text-slate-800 mb-1">2. Productos del catálogo</h3>
          <p class="text-xs text-slate-400 mb-3">
            Selecciona productos existentes. El precio se toma del catálogo.
          </p>
          <div class="flex gap-2 mb-3">
            <input
              type="text"
              [(ngModel)]="terminoBusqueda"
              (keyup.enter)="buscarProducto()"
              placeholder="Buscar por nombre o código..."
              class="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm"
            /><button
              type="button"
              class="rounded-lg bg-slate-600 px-4 py-2 text-sm text-white"
              (click)="buscarProducto()"
            >
              Buscar
            </button>
            <button
              type="button"
              class="rounded-lg bg-emerald-600 px-3 py-2 text-sm text-white"
              (click)="abrirCrearProducto()"
            >
              + Nuevo
            </button>
          </div>
          <div class="max-h-60 overflow-y-auto rounded-xl border border-slate-200 bg-white divide-y divide-slate-50">
            @for (p of productos(); track p.id) {
              <div
                class="flex items-center justify-between py-2.5 px-3.5 hover:bg-accent-50 cursor-pointer text-sm transition-colors"
                (click)="agregarProductoDb(p)"
              >
                <div class="min-w-0 flex-1 mr-2">
                  <span class="text-slate-700 truncate block">{{ p.nombre }}</span
                  ><span class="text-slate-400 text-[11px]">{{ p.codigo }}</span>
                </div>
                <span class="text-slate-700 font-semibold text-sm whitespace-nowrap">{{
                  p.precio_venta | currency: 'S/ '
                }}</span>
              </div>
            }
          </div>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <h3 class="font-semibold text-slate-800 mb-1">3. Producto manual</h3>
          <p class="text-xs text-slate-400 mb-3">Para productos que no están en el catálogo.</p>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-2 mb-2">
            <div class="col-span-2 md:col-span-1">
              <label class="text-xs text-slate-500">Descripción *</label
              ><input
                type="text"
                [(ngModel)]="productoManual().descripcion"
                placeholder="Ej: Servicio de consultoría"
                class="w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm"
              />
            </div>
            <div>
              <label class="text-xs text-slate-500">Precio *</label
              ><input
                type="number"
                [(ngModel)]="productoManual().precio_unitario"
                placeholder="S/. 100"
                class="w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm"
                min="0"
                step="0.01"
              />
            </div>
            <div>
              <label class="text-xs text-slate-500">Cant. *</label
              ><input
                type="number"
                [(ngModel)]="productoManual().cantidad"
                placeholder="1"
                class="w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm"
                min="1"
              />
            </div>
            <div>
              <label class="text-xs text-slate-500">Desc. línea</label
              ><input
                type="number"
                [(ngModel)]="productoManual().descuento"
                placeholder="0"
                class="w-full rounded-lg border border-slate-300 px-2 py-1.5 text-sm"
                min="0"
                step="0.01"
              />
            </div>
            <div>
              <label class="text-xs text-slate-500">Unidad</label
              ><app-select
                [options]="unidadesSunat"
                [(value)]="productoManual().unidad"
                [filter]="true"
                class="w-full text-sm"
              />
            </div>
          </div>
          <button
            type="button"
            class="rounded-lg bg-emerald-600 px-4 py-1.5 text-sm text-white"
            (click)="agregarProductoManual()"
          >
            + Agregar
          </button>
        </div>
      </div>
      <div class="space-y-4">
        <div class="bg-white rounded-lg shadow p-4">
          <h3 class="font-semibold text-slate-800 mb-3">Comprobante</h3>
          <label class="block text-xs text-slate-500 mb-1">Tipo</label>
          <div class="flex gap-2 mb-3">
            @for (doc of tipoDocumentos(); track doc) {
              <button
                class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                [class.bg-blue-600]="formFacturacion().controlValue().tipo_documento === doc"
                [class.text-white]="formFacturacion().controlValue().tipo_documento === doc"
                [class.bg-gray-200]="formFacturacion().controlValue().tipo_documento !== doc"
                [class.text-gray-700]="formFacturacion().controlValue().tipo_documento !== doc"
                (click)="selectTipoDocumento(doc)"
              >
                {{ doc === 'FACTURA' ? 'Factura' : 'Boleta' }}
              </button>
            }
          </div>
          <label class="block text-xs text-slate-500 mb-1">IGV</label>
          <div class="flex gap-2 mb-3">
            @for (o of opcionesIgv; track o.valor) {
              <button
                class="px-3 py-1.5 rounded-lg text-sm font-medium transition-colors"
                [class.bg-blue-600]="formFacturacion().controlValue().igv_porcentaje === o.valor"
                [class.text-white]="formFacturacion().controlValue().igv_porcentaje === o.valor"
                [class.bg-gray-200]="formFacturacion().controlValue().igv_porcentaje !== o.valor"
                [class.text-gray-700]="formFacturacion().controlValue().igv_porcentaje !== o.valor"
                (click)="formFacturacion().controlValue().igv_porcentaje = o.valor"
              >
                {{ o.label }}
              </button>
            }
          </div>
          <label class="block text-xs text-slate-500 mb-1">Descuento global (S/.)</label
          ><input
            type="number"
            [formField]="$any(formFacturacion.descuento)"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm mb-3"
            step="0.01"
          />
          <label class="block text-xs text-slate-500 mb-1">Observaciones</label
          ><textarea
            [formField]="$any(formFacturacion.observaciones)"
            class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
            rows="2"
          ></textarea>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <label class="flex items-center gap-3 cursor-pointer"
            ><input
              type="checkbox"
              [formField]="$any(formFacturacion.descontar_inventario)"
              class="h-4 w-4 rounded accent-blue-600" /><span class="text-sm text-slate-700"
              >Descontar del inventario</span
            ><i
              class="bi bi-info-circle text-slate-400 text-xs"
              appTooltip="Los productos del catálogo descontarán stock."
            ></i
          ></label>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              class="h-4 w-4 accent-green-600 rounded"
              [checked]="sendWhatsApp()"
              (change)="sendWhatsApp.set(!sendWhatsApp())"
            />
            <span class="text-sm text-slate-700">Enviar por WhatsApp</span>
          </label>
          @if (sendWhatsApp() && !disableWhatsApp()) {
            <p class="text-xs text-green-600 mt-1">
              Se enviará al: {{ formFacturacion().controlValue().cliente?.numero_celular }}
            </p>
          }
          @if (showWhatsAppPhoneInput()) {
            <div class="mt-2">
              <app-whatsapp-phone-input
                [(numeroCelular)]="whatsAppNumber"
                [(selectedCountryCode)]="whatsAppCountryCode"
              />
            </div>
          }
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <h3 class="font-semibold text-slate-800 mb-3">Items ({{ items().length }})</h3>
          <div class="space-y-1 max-h-48 overflow-y-auto">
            @for (item of items(); track $index) {
              <div class="flex items-center justify-between py-1 text-sm border-b border-slate-100">
                <div class="flex-1 min-w-0">
                  <p class="truncate text-slate-700">{{ item.descripcion }}</p>
                  <p class="text-xs text-slate-400">
                    {{ item.cantidad }} × {{ item.precio_unitario | currency: 'S/ ' }}
                    @if (item.descuento) {
                      <span class="text-red-400">(-{{ item.descuento | currency: 'S/ ' }})</span>
                    }
                  </p>
                </div>
                <span class="font-medium text-slate-800">{{
                  item.cantidad * item.precio_unitario - (item.descuento ?? 0) | currency: 'S/ '
                }}</span
                ><button class="ml-2 text-red-400 hover:text-red-600" (click)="quitarItem($index)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            }
          </div>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <div class="space-y-1 text-sm mb-4">
            <div class="flex justify-between">
              <span class="text-slate-500">Subtotal</span
              ><span class="font-medium">{{ subtotal() | currency: 'S/ ' }}</span>
            </div>
            @if (descuentoLineas() > 0) {
              <div class="flex justify-between">
                <span class="text-red-500">Desc. líneas</span
                ><span class="font-medium text-red-500"
                  >-{{ descuentoLineas() | currency: 'S/ ' }}</span
                >
              </div>
            }
            @if (formFacturacion().controlValue().descuento > 0) {
              <div class="flex justify-between">
                <span class="text-red-500">Desc. global</span
                ><span class="font-medium text-red-500"
                  >-{{ formFacturacion().controlValue().descuento | currency: 'S/ ' }}</span
                >
              </div>
            }
            <div class="flex justify-between text-base font-bold pt-2 border-t">
              <span>Total</span><span>{{ total() | currency: 'S/ ' }}</span>
            </div>
          </div>
          <button
            class="w-full rounded-lg bg-blue-600 py-3 text-sm font-semibold text-white transition hover:bg-blue-500 disabled:opacity-60"
            [disabled]="cargando() || items().length === 0"
            (click)="emitir()"
          >
            @if (cargando()) {
              Enviando...
            } @else {
              Emitir
              {{
                formFacturacion().controlValue().tipo_documento === 'FACTURA' ? 'Factura' : 'Boleta'
              }}
            }
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ═══════════ VISTA GUÍAS ═══════════ -->
  @if (vista() === 'guias') {
    <div class="grid grid-cols-1 lg:grid-cols-5 gap-4">
      <!-- COLUMNA IZQUIERDA: Datos del traslado + Destinatario -->
      <div class="lg:col-span-3 space-y-4">
        <!-- Datos del Traslado (General + Puntos) -->
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <div class="flex items-center gap-2 mb-4">
            <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-50 text-accent-600 ring-1 ring-accent-100">
              <i class="bi bi-truck text-sm"></i>
            </span>
            <h3 class="font-semibold text-slate-800">Datos del Traslado</h3>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Tipo de guía</label>
              <app-select
                [options]="[
                  { label: 'REMITENTE', value: 'REMITENTE' },
                  { label: 'TRANSPORTISTA', value: 'TRANSPORTISTA' },
                ]"
                [(value)]="formGuia().tipo_guia"
                class="w-full text-sm"
              />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Serie</label>
              <input type="text" [(ngModel)]="formGuia().serie"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Motivo de traslado</label>
              <app-select [options]="motivosTraslado" [(value)]="formGuia().motivo_traslado" [filter]="true" class="w-full text-sm" />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Modalidad</label>
              <app-select [options]="modalidades" [(value)]="formGuia().modalidad_de_transporte" class="w-full text-sm" />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Fecha de traslado</label>
              <input type="date" [(ngModel)]="formGuia().fecha_inicio_traslado"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500" />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Peso bruto (kg)</label>
              <app-input-number [(value)]="formGuia().peso_bruto_total" [step]="0.001" class="w-full text-sm" />
            </div>
            <div class="sm:col-span-2">
              <label class="text-xs font-medium text-slate-500 mb-1 block">N° de bultos</label>
              <input type="number" [(ngModel)]="formGuia().numero_bultos"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            </div>
          </div>

          <div class="mt-5 pt-4 border-t border-slate-100">
            <label class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3 block">Origen y Destino</label>
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="text-xs font-medium text-slate-500 mb-1 block">Ubigeo partida</label>
                <input type="text" [(ngModel)]="formGuia().punto_partida_ubigeo"
                  class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
              </div>
              <div>
                <label class="text-xs font-medium text-slate-500 mb-1 block">Dir. partida</label>
                <input type="text" [(ngModel)]="formGuia().punto_partida_direccion"
                  class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
              </div>
              <div>
                <label class="text-xs font-medium text-slate-500 mb-1 block">Ubigeo llegada</label>
                <input type="text" [(ngModel)]="formGuia().punto_llegada_ubigeo"
                  class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
              </div>
              <div>
                <label class="text-xs font-medium text-slate-500 mb-1 block">Dir. llegada</label>
                <input type="text" [(ngModel)]="formGuia().punto_llegada_direccion"
                  class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
              </div>
            </div>
          </div>
        </div>

        <!-- Destinatario -->
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <div class="flex items-center gap-2 mb-4">
            <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-600 ring-1 ring-teal-100">
              <i class="bi bi-person-badge text-sm"></i>
            </span>
            <h3 class="font-semibold text-slate-800">Destinatario</h3>
          </div>
          <app-buscador-cliente [mostar_creador]="true" (clienteSelected)="onClienteSeleccionado($event)" />
          <div class="grid grid-cols-2 gap-3 mt-4">
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">Tipo doc</label>
              <app-select
                [options]="[{ label: '6 - RUC', value: '6' }, { label: '1 - DNI', value: '1' }]"
                [(value)]="formGuia().destinatario_tipo_documento" class="w-full text-sm" />
            </div>
            <div>
              <label class="text-xs font-medium text-slate-500 mb-1 block">N° Documento</label>
              <input type="text" [(ngModel)]="formGuia().destinatario_numero_documento"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            </div>
            <div class="col-span-2">
              <label class="text-xs font-medium text-slate-500 mb-1 block">Denominación / Razón social</label>
              <input type="text" [(ngModel)]="formGuia().destinatario_denominacion"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            </div>
            <div class="col-span-2">
              <label class="text-xs font-medium text-slate-500 mb-1 block">Dirección</label>
              <input type="text" [(ngModel)]="formGuia().destinatario_direccion"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            </div>
          </div>
        </div>
      </div>

      <!-- COLUMNA DERECHA: Items + Docs + Acción -->
      <div class="lg:col-span-2 space-y-4">
        <!-- Items -->
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-50 text-amber-600 ring-1 ring-amber-100">
                <i class="bi bi-box-seam text-sm"></i>
              </span>
              <h3 class="font-semibold text-slate-800">Items <span class="text-slate-400 font-normal text-sm">({{ itemsGuia().length }})</span></h3>
            </div>
          </div>

          <!-- Add item row -->
          <div class="flex gap-2 mb-3">
            <input type="text" [(ngModel)]="nuevoItemGuia().codigo_interno" placeholder="Código"
              class="w-20 rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <input type="text" [(ngModel)]="nuevoItemGuia().descripcion" placeholder="Descripción del producto"
              class="flex-1 rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <input type="number" [(ngModel)]="nuevoItemGuia().cantidad" placeholder="Cant" min="1"
              class="w-16 rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <button class="shrink-0 rounded-lg bg-teal-600 hover:bg-teal-500 px-4 py-2 text-xs text-white font-medium transition-colors"
              (click)="agregarItemGuia()">
              <i class="bi bi-plus"></i> Agregar
            </button>
          </div>

          <!-- Items list -->
          <div class="max-h-52 overflow-y-auto rounded-lg border border-slate-100 divide-y divide-slate-50">
            @for (item of itemsGuia(); track $index) {
              <div class="flex items-center justify-between py-2.5 px-3 text-xs group hover:bg-slate-50 transition-colors">
                <div class="min-w-0 flex-1 mr-2">
                  <span class="text-slate-700 font-medium">{{ item.descripcion || item.codigo_interno || 'Sin descripción' }}</span>
                  @if (item.codigo_interno) {
                    <span class="text-slate-400 ml-2">{{ item.codigo_interno }}</span>
                  }
                </div>
                <span class="text-slate-500 whitespace-nowrap mr-3">{{ item.cantidad }} {{ item.unidad_de_medida }}</span>
                <button class="text-slate-300 hover:text-rose-500 transition-colors shrink-0 opacity-0 group-hover:opacity-100"
                  (click)="quitarItemGuia($index)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            } @empty {
              <div class="py-6 text-xs text-slate-400 text-center">
                <i class="bi bi-inbox text-lg block mb-1 opacity-50"></i>
                Agrega los productos a transportar
              </div>
            }
          </div>
        </div>

        <!-- Docs Relacionados -->
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <div class="flex items-center gap-2 mb-4">
            <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-purple-50 text-purple-600 ring-1 ring-purple-100">
              <i class="bi bi-files text-sm"></i>
            </span>
            <h3 class="font-semibold text-slate-800">Documentos Relacionados</h3>
          </div>

          <div class="grid grid-cols-2 gap-2 mb-3">
            <input type="text" [(ngModel)]="nuevoDoc().documento" placeholder="Tipo doc"
              class="w-full rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <input type="text" [(ngModel)]="nuevoDoc().serie" placeholder="Serie"
              class="w-full rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <input type="number" [(ngModel)]="nuevoDoc().numero" placeholder="Número"
              class="w-full rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
            <div class="flex gap-2">
              <input type="text" [(ngModel)]="nuevoDoc().ruc_emisor" placeholder="RUC emisor"
                class="flex-1 rounded-lg border border-slate-200 px-2.5 py-2 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400" />
              <button class="shrink-0 rounded-lg bg-teal-600 hover:bg-teal-500 px-3 py-2 text-xs text-white font-medium transition-colors"
                (click)="agregarDoc()">
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>

          <div class="max-h-40 overflow-y-auto rounded-lg border border-slate-100 divide-y divide-slate-50">
            @for (doc of docsRelacionados(); track $index) {
              <div class="flex items-center justify-between py-2.5 px-3 text-xs group hover:bg-slate-50 transition-colors">
                <div class="min-w-0 flex-1 mr-2">
                  <span class="text-slate-700">{{ doc.documento }} {{ doc.serie }}-{{ doc.numero }}</span>
                  <span class="text-slate-400 ml-2">RUC: {{ doc.ruc_emisor }}</span>
                </div>
                <button class="text-slate-300 hover:text-rose-500 transition-colors shrink-0 opacity-0 group-hover:opacity-100"
                  (click)="quitarDoc($index)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            } @empty {
              <div class="py-4 text-xs text-slate-400 text-center">Sin documentos</div>
            }
          </div>
        </div>

        <!-- Submit -->
        <button
          class="w-full rounded-xl bg-accent-600 hover:bg-accent-500 active:bg-accent-700 py-3 text-sm font-semibold text-white transition-colors shadow-sm flex items-center justify-center gap-2"
          (click)="crearGuia()">
          <i class="bi bi-check2-circle"></i>
          Crear Guía de Remisión
        </button>
      </div>
    </div>
  }

  <!-- ═══════════ VISTA HISTORIAL ═══════════ -->
  @if (vista() === 'historial') {
    <app-filtros-reporte>
      <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
          <div class="sm:col-span-2 lg:col-span-1">
            <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2"
              ><i class="bi bi-calendar-range"></i> Rango de fechas</label
            >
            <div class="flex flex-col gap-2">
              <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300 w-full">
                <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0"><i class="bi bi-calendar text-sm"></i></span>
                <app-datepicker
                  [formField]="$any(formHistorial.rangoFecha)"
                  selectionMode="range"
                  [maxDate]="maxDate"
                  placeholder="Seleccione un rango"
                  dateFormat="dd/mm/yy"
                  [showButtonBar]="true"
                  [borderless]="true"
                  class="w-full"
                />
              </div>
            </div>
          </div>
          <div class="sm:col-span-1">
            <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2"
              ><i class="bi bi-funnel"></i> Tipo</label
            >
            <app-select
              [formField]="$any(formHistorial.tipo)"
              class="w-full"
              placeholder="Todos"
              [options]="opcionesTipo"
            />
          </div>
          <div class="sm:col-span-1">
            <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2"
              ><i class="bi bi-arrow-left-right"></i> Estado</label
            >
            <app-select
              [formField]="$any(formHistorial.estado)"
              class="w-full"
              placeholder="Todos"
              [options]="opcionesEstado"
            />
          </div>
        </div>
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
          <button
            type="submit"
            class="px-3 sm:px-4 py-2 sm:py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
          >
            <i class="bi bi-search"></i><span class="hidden sm:inline">Buscar</span>
          </button>
          <button
            type="button"
            (click)="limpiarFiltros()"
            class="px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
          >
            <i class="bi bi-arrow-clockwise"></i><span class="hidden sm:inline">Limpiar</span>
          </button>
        </div>
      </form>
    </app-filtros-reporte>

    <div class="bg-white rounded-lg shadow mt-4">
      <app-tabla
        titulo="Historial de emisiones"
        [datos]="paginacion()?.data ?? []"
        [columnas]="columnasHistorial"
        [accionesTemplate]="acciones"
      >
        <ng-template #acciones let-item>
          <div class="flex gap-2 justify-center">
            <button
              class="text-blue-500 hover:text-blue-700 text-xs font-medium"
              (click)="abrirDetalle(item)"
            >
              Ver
            </button>
            @if (item.estado_sunat === 'ACEPTADO' && item.tipo_documento) {
              <button
                class="text-red-500 hover:text-red-700 text-xs font-medium"
                (click)="abrirAnular(item)"
              >
                Anular
              </button>
            }
            @if (item.estado_sunat === 'RECHAZADO' && item.tipo_documento) {
              <button
                class="text-amber-600 hover:text-amber-800 text-xs font-medium"
                (click)="reemitir(item.id)"
              >
                Reemitir
              </button>
            }
            @if (item.estado === 'BORRADOR' && !item.tipo_documento) {
              <button
                class="text-emerald-600 hover:text-emerald-800 text-xs font-medium"
                (click)="emitirGuia(item.id)"
              >
                Emitir GRE
              </button>
            }
          </div>
        </ng-template>
        <ng-template #tipoTemplate let-item
          ><span class="text-xs">{{ item.tipo }}</span></ng-template
        >
        <ng-template #totalTemplate let-item>{{
          item.total ? (item.total | currency: 'S/ ') : '-'
        }}</ng-template>
      </app-tabla>
      @if (!paginacion() || paginacion()!.data.length === 0) {
        <div class="text-center text-slate-400 py-12">
          <i class="bi bi-inbox text-3xl block mb-2"></i>
          <p>No hay emisiones registradas</p>
        </div>
      }
    </div>
    @if (paginacion() !== null) {
      <app-paginacion
        [items]="paginacion()!.data"
        [itemsPorPagina]="paginacion()!.size"
        [totalItems]="paginacion()!.total"
        (paginaCambiada)="cambiarPagina($event)"
      />
    }
  }
</div>

<app-dialog
  header="Anular comprobante"
  [modal]="true"
  [(visible)]="modalAnular"
  size="sm"
>
  <div class="space-y-3">
    <p class="text-sm text-slate-600">¿Estás seguro de anular este comprobante?</p>
    <label class="block text-xs text-slate-500">Motivo</label
    ><textarea
      [(ngModel)]="motivoAnulacion"
      class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
      rows="2"
      placeholder="Ej: Error en los datos del cliente"
    ></textarea>
  </div>
  <div class="flex justify-end gap-2 mt-4">
    <button
      class="rounded-lg border border-slate-300 px-4 py-2 text-sm"
      (click)="modalAnular.set(false)"
    >
      Cancelar</button
    ><button
      class="rounded-lg bg-red-600 px-4 py-2 text-sm text-white"
      (click)="confirmarAnular()"
      [disabled]="!motivoAnulacion.trim()"
    >
      Anular
    </button>
  </div>
</app-dialog>

<app-dialog
  header="Detalle de emisión"
  [modal]="true"
  [(visible)]="modalDetalle"
  size="xl"
>
  @if (emisionDetalle(); as e) {
    <div class="space-y-3 text-sm">
      <div class="grid grid-cols-2 gap-2">
        <div>
          <span class="text-slate-500">Tipo:</span> <span class="font-medium">{{ e.tipo }}</span>
        </div>
        <div>
          <span class="text-slate-500">N°:</span> <span class="font-medium">{{ e.numero }}</span>
        </div>
        <div>
          <span class="text-slate-500">Cliente:</span>
          <span class="font-medium">{{ e.cliente_nombre || e.destinatario }}</span>
        </div>
        <div>
          <span class="text-slate-500">DNI/RUC:</span>
          <span class="font-medium">{{ e.cliente_dniRuc }}</span>
        </div>
        <div>
          <span class="text-slate-500">Total:</span>
          <span class="font-medium">{{ e.total ? (e.total | currency: 'S/ ') : '-' }}</span>
        </div>
        <div>
          <span class="text-slate-500">Estado:</span>
          <span class="font-medium">{{ e.estado }}</span>
        </div>
        <div>
          <span class="text-slate-500">Fecha:</span>
          <span class="font-medium">{{ e.created_at }}</span>
        </div>
        @if (e.sunat_ticket) {
          <div>
            <span class="text-slate-500">Ticket:</span>
            <span class="font-mono text-xs">{{ e.sunat_ticket }}</span>
          </div>
        }
      </div>
      @if (e.observaciones) {
        <div>
          <span class="text-slate-500">Obs:</span>
          <p class="text-slate-600">{{ e.observaciones }}</p>
        </div>
      }
      @if (e.sunat_response && e.tipo_documento) {
        <div class="border-t pt-3 mt-3">
          <span class="text-xs text-slate-500 font-medium block mb-2">Respuesta SUNAT</span>
          <div
            class="bg-slate-50 rounded-lg p-3 text-xs"
            [innerHTML]="e.sunat_response | sunatRespuesta"
          ></div>
        </div>
      }
      @if (e.items?.length) {
        <div class="border-t pt-3 mt-3">
          <span class="text-xs text-slate-500 font-medium block mb-2">Items</span>
          <div class="space-y-1">
            @for (item of e.items; track $index) {
              <div class="flex justify-between text-xs">
                <span>{{ item.descripcion }}</span
                ><span
                  >{{ item.cantidad }} {{ item.unidad_de_medida || '' }}
                  {{
                    item.precio_unitario ? '× ' + (item.precio_unitario | currency: 'S/ ') : ''
                  }}</span
                >
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <div class="flex justify-end mt-4">
    <button
      class="rounded-lg border border-slate-300 px-4 py-2 text-sm"
      (click)="modalDetalle.set(false)"
    >
      Cerrar
    </button>
  </div>
</app-dialog>

<app-dialog header="Crear Producto" [modal]="true" [(visible)]="modalCrearProducto" size="md">
  @if (categorias().length) {
    <app-crear-producto [categorias]="categorias()" (crear)="onProductoCreado($event)" />
  }
</app-dialog>
